import { useFormContext } from 'react-hook-form';
import { FILTER_SECTIONS, Filter, MultipleSelectorFieldProps } from '@anytag/shared-molecules';
import {
  AgeField,
  ReachField,
  SaveRateField,
  FollowerField,
  PostPriceField,
  StoryPriceField,
  DemographicField,
  FollowerGrowthRate,
  EngagementRateField,
  CampaignCategoryField,
  InfluencerStatusField,
  RegionAndProvinceField,
  InfluencerCategoryField,
  TalentAgencyPartnerField
} from '../../shared';
import { AdvancedFilterDefaultProps, InfluencersFilterFormKeys } from '../../schemaTypes';
import {
  defaultInstagramInfluencersFormValues,
  InstagramInfluencersFilterFormKeys,
  InstagramInfluencersFilterFormValues
} from '../schemaTypes';

export const AdvancedFilter = ({ count, onSubmit }: AdvancedFilterDefaultProps) => {
  const { reset, setValue, getValues } = useFormContext<InstagramInfluencersFilterFormValues>();

  const values = getValues();

  const handleClear = () => {
    reset({
      ...defaultInstagramInfluencersFormValues,
      // Basic filter
      keyword: values.keyword,
      genders: values.genders,
      countryIds: values.countryIds
    });
  };

  const handleCampaignCategoriesChange: MultipleSelectorFieldProps<InfluencersFilterFormKeys>['onChange'] = (
    fieldName,
    selectedValues,
    campaignCategoryOptions
  ) => {
    setValue(fieldName as InstagramInfluencersFilterFormKeys, [...selectedValues]);
    setValue(
      'interests',
      campaignCategoryOptions.reduce<string[]>(
        (arr, category) => (selectedValues.includes(String(category.value)) ? [...arr, String(category.label)] : arr),
        []
      )
    );
  };

  return (
    <Filter.MoreFilterPopover
      count={count}
      onClear={handleClear}
      onSubmit={onSubmit}
      items={[
        {
          value: FILTER_SECTIONS.InfluencerAttributes,
          title: FILTER_SECTIONS.InfluencerAttributes,
          node: (
            <>
              <AgeField />
              <InfluencerStatusField />
              <TalentAgencyPartnerField />
              <InfluencerCategoryField />
              <RegionAndProvinceField />
              <CampaignCategoryField onChange={handleCampaignCategoriesChange} />
            </>
          )
        },
        {
          value: FILTER_SECTIONS.Audiences,
          title: FILTER_SECTIONS.Audiences,
          node: <DemographicField />
        },
        {
          value: FILTER_SECTIONS.PerformanceFilter,
          title: FILTER_SECTIONS.PerformanceFilter,
          node: (
            <>
              <FollowerField />
              <EngagementRateField />
              <ReachField />
              <SaveRateField />
              <PostPriceField />
              <StoryPriceField />
              <FollowerGrowthRate />
            </>
          )
        }
      ]}
    />
  );
};
